module.exports = __webpack_public_path__ + "static/media/m-heroimage.87ddb194.png";